import {Component, input, signal} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import {IItem} from '../../../types/IItem';
import {IconsComponent} from '../icons/icons.component';

@Component({
  selector: 'app-item-image',
  standalone: true,
  imports: [NgOptimizedImage, IconsComponent],
  templateUrl: './item-image.component.html',
  styleUrl: './item-image.component.css'
})
export class ItemImageComponent {
  item = input.required<IItem>();
  height = input<string>('35');
  width = input<string>('35');

  error = signal(false);
}
